// @flow
import { createContext, useContext } from 'react';

export const SPUserCommitDetailsContext = createContext({});

export const useSPUserCommitDetailsContext = () => useContext(SPUserCommitDetailsContext);
